import styled from 'styled-components';
import bgModalImg from 'assets/images/banner-bond.png';

export const Container = styled.div`
  .modal-bond {
    background: url('${bgModalImg}') no-repeat 95% center;
    background-size: 50%;
    height: 410px;

    @media only screen and (max-width: 368px) {
      background: none;
    }
  }

  .close {
    position: absolute;
    right: 10px;
    top: 5px;
  }

  .badge-new {
    color: ${(props) => props.theme.$black};
    background: ${(props) => props.theme.$warning};
  }

  .text-green {
    color: ${(props) => props.theme.$medium_green};
  }
`;
